import {
  Icon,
  type IconProps,
  Pill,
  type PillProps,
  PillWrapper,
  Text
} from "@theorgchartdev/storybook";
import { appstr } from "@coreapp/utils/appstr";

/**
 * Pill color per isolved agent status we know about, keyed lowercase. The
 * status list is payload-defined, so any unknown non-blank value falls back to
 * the default pill rather than rendering nothing — Status is a locked header slot.
 */
export const AgentStatusPillColor: Record<string, NonNullable<PillProps["color"]>> = {
  active: "success",
  paused: "warning",
  inactive: "neutral"
};

const AgentStatusIconModifiers: Record<string, IconProps["modifier"]> = {
  active: "success",
  paused: "warning",
  inactive: "secondary"
};

type Props = {
  status?: unknown;
};

export const AgentStatusPill = ({ status }: Props) => {
  const label = typeof status === "string" ? status.trim() : "";

  if (!label) {
    return <Text size="small">--</Text>;
  }

  const statusKey = label.toLowerCase();
  // Known statuses localize (Active / Paused / Inactive keys); unknown
  // payload-defined values render verbatim.
  const displayLabel = statusKey in AgentStatusPillColor ? appstr(label) : label;

  return (
    <PillWrapper>
      <Pill
        className="oc-relative"
        label={displayLabel}
        color={AgentStatusPillColor[statusKey]}
        leftContent={
          <Icon
            name="circle-filled"
            size="small"
            modifier={AgentStatusIconModifiers[statusKey] ?? "secondary"}
          />
        }
      />
    </PillWrapper>
  );
};
